import { useEffect, useState } from "react";
import { descargarFirmaEvaluacion } from "../../shared/evaluacionesApi";

export function useImagenFirma(evaluacionEmpleadoID, tipoFirma) {
  const [imagen, setImagen] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let vigente = true;
    let objectUrl;
    setImagen(null);
    setError("");

    descargarFirmaEvaluacion(evaluacionEmpleadoID, tipoFirma)
      .then(blob => {
        if (!vigente) return;
        objectUrl = URL.createObjectURL(blob);
        setImagen(objectUrl);
      })
      .catch(error => {
        if (vigente) setError(error.message);
      });

    return () => {
      vigente = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [evaluacionEmpleadoID, tipoFirma]);

  return { imagen, error };
}
